module.exports = __webpack_public_path__ + "static/media/tunnelin_devices.257fe251.jpg";